import CryptoJS from 'crypto-js';

/**
 * 获取 OSS 签名 URL (替代 ali-oss SDK)
 * @param {Object} params
 * @param {string} params.accessKeyId
 * @param {string} params.accessKeySecret
 * @param {string} params.stsToken
 * @param {string} params.bucket
 * @param {string} params.endpoint - 例如 https://file.marathonbm.com
 * @param {string} params.objectKey - 例如 2024_02/xxx.png
 * @returns {string} 签名后的 URL
 */
export function getSignatureUrl({
	accessKeyId,
	accessKeySecret,
	stsToken,
	bucket,
	region,
	endpoint,
	objectKey,
	exp,
	cname
}) {
	if (!accessKeyId || !accessKeySecret || !bucket || !endpoint || !objectKey) {
		console.error('getSignatureUrl: missing required parameters', {
			accessKeyId,
			hasSecret: !!accessKeySecret,
			bucket,
			endpoint,
			objectKey
		});
		return endpoint + '/' + objectKey; // 降级处理：返回原始链接
	}

	// 过期时间：当前时间 + 3600秒 (1小时)
	const expires = Math.floor(Date.now() / 1000) + exp;
	const method = 'GET';

	// 1. 处理 Key
	// 去掉开头的 /
	let rawKey = objectKey;
	if (rawKey.startsWith('/')) {
		rawKey = rawKey.substring(1);
	}

	// 处理可能存在的 Query String (例如 ?x-oss-process=...)
	// 签名时 CanonicalizedResource 不应包含这些参数（除非是特定子资源，这里简化处理，只取 path）
	let pathPart = rawKey;
	let queryPart = '';
	const questionMarkIndex = rawKey.indexOf('?');
	if (questionMarkIndex !== -1) {
		pathPart = rawKey.substring(0, questionMarkIndex);
		queryPart = rawKey.substring(questionMarkIndex);
	}

	// 2. 构建 CanonicalizedResource
	const decodedKey = decodeURIComponent(pathPart);
	let canonicalizedResource = `/${bucket}/${decodedKey}`;

	// 收集需要签名的参数
	let signParams = [];

	if (queryPart) {
		// queryPart 类似于 ?x-oss-process=image/resize...
		// 去掉开头的 ?
		const query = queryPart.substring(1);
		signParams.push(query);
	}

	if (stsToken) {
		signParams.push(`security-token=${stsToken}`);
	}

	// 对参数进行排序并拼接
	if (signParams.length > 0) {
		signParams.sort(); // 阿里云要求参数按字典序排序
		canonicalizedResource += '?' + signParams.join('&');
	}

	const stringToSign = `${method}\n\n\n${expires}\n${canonicalizedResource}`;

	// 使用 CryptoJS 计算签名
	const signature = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA1(stringToSign, accessKeySecret));
	const encodedSignature = encodeURIComponent(signature);

	// 3. 构造 URL
	// URL 中的 Key 应该是编码后的
	const urlKey = pathPart.split('/').map(part => encodeURIComponent(decodeURIComponent(part))).join('/');

	let baseUrl = endpoint;
	if (baseUrl.endsWith('/')) {
		baseUrl = baseUrl.substring(0, baseUrl.length - 1);
	}

	// 4. 拼 URL（⚠️ bucket.region）
	let url = ''
	if(!cname){
		// oss域名
		url =
			`https://${bucket}.${region}.aliyuncs.com/${encodeURI(objectKey)}?OSSAccessKeyId=${accessKeyId}&Expires=${expires}&Signature=${encodedSignature}`;
	}else{
		// 自定义域名
		url = `${baseUrl}/${urlKey}?OSSAccessKeyId=${accessKeyId}&Expires=${expires}&Signature=${encodedSignature}`;
	}
	
	if (stsToken) {
		url += `&security-token=${encodeURIComponent(stsToken)}`;
	}

	if (queryPart) {
		url += queryPart.replace('?', '&');
	}

	return url;
}